import { computed } from 'vue'
import { useAuthBff } from '@/composables/bff/useAuthBff.ts'
import { config } from '@/config'

export function useFeatureFlags() {
  const isProduction = config.env === 'production'
  const isLocalDev = config.env === 'dev'
  const isSandbox = config.env === 'sandbox'

  const isPreProduction = isProduction || config.env === 'staging'

  const { organization } = useAuthBff()

  const hasOrgToggle = (toggle: string) =>
    computed(
      () =>
        organization.value?.feature_toggles.some((t) => t.name === toggle && t.enabled) ?? false,
    )

  return {
    isProduction,
    isLocalDev,
    isSandbox,
    isPreProduction,
    showDevFeatures: !isProduction,
    showPreReleaseFeatures: !isPreProduction,
    showAgentOverride: hasOrgToggle('quality-flags'),
    showMcpConfigOverride: hasOrgToggle('mcp-config-override'),
    showFeatureToggles: hasOrgToggle('feature-toggles'),
    showContextualPromptOverride: hasOrgToggle('contextual-prompt-override'),
    showAdditionalParameters: hasOrgToggle('additional-parameters'),
    showPersonaOverride: hasOrgToggle('persona-override'),
    showToolsTab: isSandbox || isLocalDev || hasOrgToggle('mcp-config-override'),
    showArabicFeatures: hasOrgToggle('arabic-voices'),
  }
}
